import { Gauge, Megaphone, Shrink } from 'lucide-react';
import { Link } from 'react-router';

import { cn } from '~/styles/extended-theme';

import { Button } from '../ui/button';

import { FeatureCard } from './feature-card';

export function GymOwnersSection() {
  const features = [
    {
      title: 'Fill your classes faster',
      icon: <Gauge size={48} className="text-destructive" />,
      description: `Online registration, easy payments, and tools that make your gym the go-to spot for fighters.`,
      imageSrc: '/img/gymowner_vp03.png',
      imageAlt: 'gym owner vp03',
    },
    {
      title: 'Promote Your Gym and Events',
      icon: <Megaphone size={48} className="text-destructive" />,
      description: `Showcase your training, coaches, and community to stand out.`,
      imageSrc: '/img/gymowner_vp02.png',
      imageAlt: 'gym owner vp02',
    },
    {
      title: 'Simplify operations',
      icon: <Shrink size={48} className="text-destructive" />,
      description: `Manage classes, schedules, check ins and payments without the hassle.`,
      imageSrc: '/img/gymowner_vp01.png',
      imageAlt: 'gym owner vp01',
    },
  ];

  return (
    <div
      className="relative flex flex-col items-center overflow-hidden pb-[50px] desktop:pb-[140px]"
      id="gym-owners-section"
    >
      <div
        className={cn(
          'absolute left-1/2 -z-10 -translate-x-1/2 overflow-hidden',
          '-top-[10px]',
          'tablet:-top-[35px]',
          'desktop:-top-[25px] desktop:translate-x-[-115px]',
        )}
      >
        <img
          src="/img/gymowner_bg.png"
          alt="gym owner bg"
          className={cn(
            'opacity-[25%]',
            'h-[301px] w-[451px] min-w-[451px]',
            'tablet:h-[576px] tablet:w-[767px] tablet:min-w-[767px]',
            'desktop:h-[715px] desktop:w-[953px] desktop:min-w-[953px]',
          )}
        />
      </div>
      <div
        className={cn(
          'flex flex-col gap-8',
          'w-[361px] pt-[230px]',
          'tablet:w-[596px] tablet:pt-[390px]',
          'desktop:w-[834px] desktop:pt-[150px]',
        )}
      >
        <div className="mb-6 flex flex-col gap-4 desktop:mb-8 desktop:w-[399px] desktop:min-w-[399px]">
          <p className="text-subtitle1 text-destructive">GYM OWNERS</p>
          <p className="font-mono text-h3 text-gray-900">
            Get Discovered.
            <br />
            Fill Your Classes.
            <br />
            Grow Your Community.
          </p>
          <p className="text-body1 text-gray-900">
            Reach new students, attract traveling athletes, and streamline your operations — all in
            one platform.
          </p>
        </div>

        {features.map((feature, index) => (
          <FeatureCard key={index} {...feature} variant="gym-owner" />
        ))}

        <div className="flex flex-col gap-4 rounded-2xl border border-gray-900 p-6 desktop:mt-8">
          <p className="text-h6 text-gray-900">
            Schedule a demo to discover how Fighters Passport can help you grow your gym.
          </p>
          <div className="flex justify-center gap-4">
            <Button
              asChild
              variant="outline"
              size="lg"
              className="px-4 text-center text-xs md:h-[42px] md:px-8 md:text-sm"
            >
              <Link to={'/request-demo'} target="_blank" rel="noreferrer">
                Schedule a Demo
              </Link>
            </Button>
            <Button
              asChild
              variant="destructive"
              size="lg"
              className="px-4 text-center text-xs text-white md:h-[42px] md:px-8 md:text-sm"
            >
              <a href="https://fighterspassport.com/contact/" target="_blank" rel="noreferrer">
                Start Growing Today
              </a>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
